export default __webpack_public_path__ + "static/es-7705b00df89edc14fef795860ce03695.svg";